import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CheckoutState } from '@store/reducers/checkout.reducer';
import { selectAuth } from './auth.selectors'; 

export const selectCheckoutState = createFeatureSelector<CheckoutState>('checkout');

export const selectCurrentStep = createSelector(
  selectCheckoutState,
  (state: CheckoutState) => state.currentStep
);

export const selectPaymentMethod = createSelector(
  selectCheckoutState,
  (state: CheckoutState) => state.paymentMethod
);

export const selectCreditCardData = createSelector(
  selectCheckoutState,
  (state: CheckoutState) => state.creditCardData
);

export const selectCheckoutLoading = createSelector(
  selectCheckoutState,
  (state: CheckoutState) => state.loading
);

export const selectCheckoutError = createSelector(
  selectCheckoutState,
  (state: CheckoutState) => state.error
);

export const selectProgressWidth = createSelector(
  selectCurrentStep,
  selectAuth,
  (currentStep, isAuthenticated) => {
    const totalSteps = isAuthenticated ? 3 : 4;
    const adjustedStep = isAuthenticated && currentStep >= 2 ? currentStep - 1 : currentStep;
    const progressPercentage = ((adjustedStep - 1) / (totalSteps - 1)) * 100;
    
    return {
      currentStep,
      totalSteps,
      adjustedStep,
      progressPercentage,
      isAuthenticated
    };
  }
);
